const {h, render, Component} = require('preact');
const GrouponValidate = require('../../../../../../groupon/frontend/validate');
const PureComponent = require('./../../../helpers/pure_component');

class EmailFormDescriptionView extends PureComponent {
  constructor(props) {
    super(props);
    this.isInputCompulsory = true;
    this.validateEmailForm = this.validateEmailForm.bind(this);
  }

  readInput() {
    return document.getElementsByClassName("email-text-area")[0].value.trim();
  }

  isInputGiven() {
    return document.getElementsByClassName("email-text-area")[0].value.trim().length > 0;
  }

  isInputValid() {
    return true;
    if (this.validateDescription()) {
      return true;
    }
    else {
      return false;
    }
  }

  validateEmailForm() {
    var isValid = false;
    if (this.isInputCompulsory && this.isInputGiven() && this.isInputValid()) {
      isValid = true;
    }

    this.props.changeEmailDescriptionBoxState(this.readInput(), isValid);
  }

  creditElement() {
    return document.getElementsByClassName('.credit_card_warning')[0];
  }

  validateDescription() {
    var isCreditInformation = GrouponValidate.creditCard(this.readInput())
    if (isCreditInformation)
      this.creditElement().css('display', 'block')
    else
      this.creditElement().css('display', 'none')
    !isCreditInformation
  }

  componentWillUnmount() {
    var textArea = document.getElementsByClassName("email-text-area")[0];
    if (textArea) {
      textArea.removeEventListener("keyup", this.validateEmailForm)
    }
  }

  componentDidMount() {
    this.validateEmailForm()
    var textArea = document.getElementsByClassName("email-text-area")[0];
    textArea.addEventListener("keyup", this.validateEmailForm)
  }

  render() {
    return (
      <div>
        <div class="please-give-us-an-id">
          <label>
            <strong id='ticket_description'>{I18n.translate('js.modules.support.whatson')}
              <span className="whats-going-on-star-color">*</span>
            </strong>
          </label>
        </div>
        <div>
        <textarea className="email-text-area" cols="80" rows="8" name="description" aria-label="Description" label="email-comments-area" />
        </div>
      </div>
    )
  }
}

module.exports = EmailFormDescriptionView